module.exports = __webpack_public_path__ + "img/op4.0658419c.png";